import React from "react";
import HomeView from "../../views/home";

const Home = () => {
  return <HomeView />;
};

export default Home;
